import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from 'ServiceWorker';
import RootProvider from 'providers/RootProvider';
import './i18n';

import { LocalStore } from 'stores/LocalRootStore';
import ErrorBoundary from 'ErrorBoundary';
import { CustomProvider } from 'saladsoft-primitive';
import reportWebVitals from './reportWebVitals';
import App from './App';

ReactDOM.render(
  <RootProvider>
    {/* <ErrorBoundary> */}
    <CustomProvider localStores={LocalStore}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </CustomProvider>
    {/* </ErrorBoundary> */}
  </RootProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerServiceWorker();
